import React from "react";
import SalesListHeaderBoxValue from "./SalesListHeaderBoxValue";

const SalesListFrozenHeader = props => {
    return(
        <div className="sales-list-header__boxes__content__values__block-of-status-contents">
            <SalesListHeaderBoxValue
				value={props.valueTotalFrozen}
				isFetching={props.isFetching}
				title="Total:"
			/>
        </div>
    )
};

export default SalesListFrozenHeader;